export default {
  init() {
	// js to fire on Abous Us page
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/about.js